import { useContext, useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { AuthContext } from 'contexts/AuthContext';

import config from 'config';

const ImpersonateView: React.FC = () => {
  const location = useLocation();
  const { authDispatch } = useContext(AuthContext);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const userEncoded = params.get('user');

    if (!userEncoded) {
      window.location.href = '/';
      return;
    }

    let userData = null;
    try {
      const userJson = decodeURIComponent(userEncoded);
      userData = JSON.parse(userJson);
    } catch (e) {
      authDispatch({ type: 'remove_user' });
      return;
    }

    // @ts-ignore
    let environment = null;
    const currentHost = window.location.hostname;
    for (const [organisation_key, organisation] of Object.entries(
      config.ORGANISATIONS,
    )) {
      if (currentHost === (organisation as any).auto_detect_host) {
        environment = organisation_key;
        break;
      }
    }

    // Update session with the new user data
    authDispatch({
      type: 'set_user',
      payload: { user: { ...userData }, environment: environment },
    });

    setTimeout(() => {
      window.location.href = '/';
    }, 300);
  }, [location.search, authDispatch]);

  return null;
};

export default ImpersonateView;
